export const AUTO = "q_auto";
export const BEST = "q_auto:best";
export const GOOD = "q_auto:good";
export const ECO = "q_auto:eco";
export const LOW = "q_auto:low";
